export enum PetColorKey {
    BLACK = "BLACK",
    WHITE = "WHITE",
    BROWN = "BROWN",
    TAN = "TAN",
    FAWN = "FAWN",
    RED = "RED",
    GOLDEN = "GOLDEN",
    CREAM = "CREAM",
    YELLOW = "YELLOW",
    ORANGE = "ORANGE",
    GRAY = "GRAY",
    BLUE = "BLUE",
    SILVER = "SILVER",
    CHOCOLATE = "CHOCOLATE",
    LIVER = "LIVER",
    APRICOT = "APRICOT",
    SABLE = "SABLE",
    BRINDLE = "BRINDLE",
    MERLE = "MERLE",
    TRICOLOR = "TRICOLOR",
    MULTICOLOR = "MULTICOLOR",
}

export enum PetSizeKey {
    EXTRA_SMALL = "XS",
    SMALL = "S",
    MEDIUM = "M",
    LARGE = "L",
    EXTRA_LARGE = "XL",
}

export enum PetAgeKey {
    BABY = "BABY",
    YOUNG = "YOUNG",
    ADULT = "ADULT",
    SENIOR = "SENIOR",
}

export enum PetSexKey {
    MALE = "MALE",
    FEMALE = "FEMALE",
}